import { render, staticRenderFns } from "./twitter_timeline_widget.vue?vue&type=template&id=6a537162&scoped=true"
import script from "./twitter_timeline_widget.vue?vue&type=script&lang=ts"
export * from "./twitter_timeline_widget.vue?vue&type=script&lang=ts"
import style0 from "./twitter_timeline_widget.vue?vue&type=style&index=0&id=6a537162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a537162",
  null
  
)

export default component.exports